//Eventer

const Eventer  = {

    triggerEvent(element, eventName) {

        if ("createEvent" in document) {
            var event = document.createEvent("HTMLEvents");
            event.initEvent(eventName, false, true);
            element.dispatchEvent(event);
        }

    },
}

export default Eventer;

